import React, { useState, useEffect } from 'react';
import { Collapse, Icon } from 'antd';
import * as ui from '@digital/ui';

import GraficoCurva from '@app/views/GraficoCurva';

import {
    ICrfRelatorioCicloOrcamentario,
    getAllCrfRelatorioCurvaEconomica
} from '@app/api/crf/crfRelatorioCicloorcamentario';

const { Panel } = Collapse;

const CurvaEconomica = () => {
    const [relatorio, setRelatorio] = useState<ICrfRelatorioCicloOrcamentario>();

    useEffect(() => {
        getAllCrfRelatorioCurvaEconomica().then((data) => {
            setRelatorio(data);
        });
    }, []);

    return (
        <>
            {relatorio ? (

                <>
                    <ui.SimpleView>
                        <ui.GridView noform>
                            <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                                <Panel key="1" header="Gráfico" style={{ border: 0 }}>
                                    <ui.Widget span={12} actions={[]}>
                                        <GraficoCurva relatorio={relatorio} carregarTabela={true} />
                                    </ui.Widget>
                                </Panel>
                            </Collapse>

                        </ui.GridView>
                    </ui.SimpleView>
                </>
            ) : (<> </>)}
        </>
    );
};

export default CurvaEconomica;
